import { createAsyncThunk } from "@reduxjs/toolkit"

import { handleApiError } from "../../../Utils/thunkHelpers"
import { getStatisticsAdmin } from "../../BusinessAccountsPage/redux/businessAccounts.thunks"
import * as services from "../services"
import { CREDITS_SLICE_NAME } from "./credits.constants"

export const getCreditsStatistics = createAsyncThunk(
  `${CREDITS_SLICE_NAME}/get_credits_statistics`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getCreditsStatistics(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const getCreditsFilterOptions = createAsyncThunk(
  `${CREDITS_SLICE_NAME}/get_credits_filter_options`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getCreditsFilterOptions(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const getCredits = createAsyncThunk(
  `${CREDITS_SLICE_NAME}/get_credits`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getCredits(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const updateCredit = createAsyncThunk(
  `${CREDITS_SLICE_NAME}/update_credit`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.updateCredit(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    dispatch(getStatisticsAdmin())
    return response.data
  }
)

export const pinCredit = createAsyncThunk(
  `${CREDITS_SLICE_NAME}/pin_credit`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.pinCredit(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const deleteCredit = createAsyncThunk(
  `${CREDITS_SLICE_NAME}/delete_credit`,
  async (id, { dispatch, rejectWithValue }) => {
    const response = await services.deleteCredit(id)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    dispatch(getStatisticsAdmin())
    return { id, message: response.data?.message?.detail || response.data?.message }
  }
)

export const getCreditsExport = createAsyncThunk(
  `${CREDITS_SLICE_NAME}/get_credits_export`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getCreditsExport(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const getCreditDetails = createAsyncThunk(
  `${CREDITS_SLICE_NAME}/get_credit_details`,
  async (id, { dispatch, rejectWithValue }) => {
    const response = await services.getCreditDetails(id)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const attachProofCredit = createAsyncThunk(
  `${CREDITS_SLICE_NAME}/attach_proof_credit`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.attachProofCredit(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const resubmitCreditRequest = createAsyncThunk(
  `${CREDITS_SLICE_NAME}/resubmit_credit_request`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.resubmitCreditRequest(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)
